import "preact/debug";
import { h, Fragment } from 'preact';
import { useContext, useState, useEffect, useRef } from 'preact/hooks';

import SearchButton from './search-button';
import DropdownPane from './dropdown-pane';

import { styled, setup } from 'goober';
import { prefix } from 'goober/prefixer';

import ThemeContext, { themes } from '../styles/color-theme-context';
import GlobalStyles from '../styles/global-styles';

const colorTheme = ()=> useContext(ThemeContext);

setup(h, prefix, colorTheme);

const NCStateUtilityButton = ( props ) => {
  const [ isOpen, setIsOpen ] = useState( false );
  const { color, alternateOffset, searchLabel } = props;

  const SearchButtonRef = useRef(null);

  const [ calculatedOffset, setCalculatedOffset ] = useState(0);

  const onEscape = (event) => {
    if ( event.key === `Escape` || event.keyCode === 27 ) {
        setIsOpen(false);
    }
  };

  useEffect(() => {
    let currentOffset = !!alternateOffset ? alternateOffset :
    SearchButtonRef.current.base.clientHeight;

    setCalculatedOffset( currentOffset );
  }, []);

  useEffect(() => {
    document.addEventListener( "keydown", onEscape, false );

    return () => document.removeEventListener("keydown", onEscape, false );
  }, [] );

  return (
    <>
      <GlobalStyles />
      <ThemeContext.Provider value={themes.[color]}>
        <div class='ncstate-utility-bar' role="navigation" aria-label="NC State Brand Utility Bar">
          <SearchButton
            ref= { SearchButtonRef }
            setIsOpen={ setIsOpen }
            isOpen={ isOpen }
          />
          {
            <DropdownPane
              isOpen={ isOpen }
              searchLabel={ searchLabel }
              topOffset={ calculatedOffset }
            />
          }
        </div>
      </ThemeContext.Provider>
    </>
  );
}

export default NCStateUtilityButton;